/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * The copyright service implementation provides a full copyrights notice in an HTML format that can be displayed to
 * the user when the copyrights link is clicked.
 *
 * The copyrights API can take as argument area which the copyrights concerns. If this argument is omitted the whole
 * world is considered.
 *
 * The API handles the "edge of the world" issue. Allowing to properly handle bounding box that is outside of world
 * extends (-180, -90, 180, 90).
 *
 * Parameters can be passed to the constructor or provided via convenient methods that can be chained until
 * the method {{#crossLink "Copyright/go:method"}}{{/crossLink}} performs the actual call.
 *
 * The call is asynchronous therefore the user have two options for receive the response:
 *  - Passing a callback function.
 *  - Use the {{#crossLink "Promise"}}{{/crossLink}} returned by the {{#crossLink "Copyright/go:method"}}{{/crossLink}}
 *    method to handle the response.
 *
 * @class Copyright
 * @module Services
 * @uses Chain
 * @constructor
 * @uses KeyMixin
 * @uses BoundingBoxMixin
 * @uses ProtocolMixin
 *
 * @param {Object} [options]
 * @param {Function} [options.callback] Callback function to use in case of success
 * @param {Function} [options.fail=default] Callback function to use in case of failure
 *
 * @param {String} [options.key] This is optional if a key was already defined globally
 * @param {Object|Array|String} [options.boundingBox] An area to extract the copyrights information for.
 *     If omitted, the whole world will be taken into consideration.
 * @param {"http"|"https"} [options.protocol="https"] Protocol's type
 * @example
 * ```js
 * tomtom.copyright()
 *   .go()
 *   .then(function(response) {
 *     console.log(response);
 *   });
 * ```
 */
define(['rest/copyright', 'model/copyright/copyright', 'services/chain',
    'services/worldEdge', 'services/copyrights/copyrightsParameters'],
function(restCopyright, model, chain, worldEdge, copyrightsParameters) {
    'use strict';

    var fields = copyrightsParameters.create();
    var copyright = restCopyright();

    /**
         * Perform the actual call to the web service.
         *
         * It receives two optional arguments. The first one is a callback function that will be used when a
         * successful response if received by the web service. The second one is another callback function
         * that will be used only in case of failure.
         *
         * Both arguments are shortcuts for the <b>callback</b> and <b>fail</b> methods respectively.
         *
         * The final response from the service is an HTML string with the copyright information that have to
         * be displayed.
         * The whole respose is wrapped into a `div` element with the id `copyrightMessage`. Country names are
         * enclosed within `h4` elements and the copyrights information per each supplier is enclose in `p`
         * elements. This makes styling with CSS fairly easy. An example response may look like this:
         *```html
         * <div id="copyrightMessage"><h4>General Copyrights:</h4>
         *   <p>© 1992 – 2016 TomTom. All rights reserved. This
         *   material is proprietary and the subject of
         *   copyright protection, database right protection
         *   and other intellectual property rights owned
         *   by TomTom or its suppliers. The use of
         *   this material is subject to the terms of a license
         *   agreement. Any unauthorized copying or disclosure
         *   of this material will lead to criminal and civil
         *   liabilities.</p>
         *   <p>Data Source © 2016 TomTom</p>
         * </div>
         * ```
         *
         * The SDK provides a Promise polyfill for browsers (IE<9) without native ECMAScript 6 support.
         *
         * @method go
         * @param {Function} [success] The callback function to be called on case of success.
         * @param {Function} [fail] The callback function to be called on case of failure.
         *     If a success callback is not given this argument will be ignored. In that case the returned Promise
         *     should be used to handle the failures.
         * @return {Promise|null} If the success callback is omitted (and wasn't defined one yet) this function
         *     will return a Promise
         */

    function addBoundingBoxParameters(data, boundingBox) {
        data.minLon = boundingBox.minLon;
        data.maxLon = boundingBox.maxLon;
        data.minLat = boundingBox.minLat;
        data.maxLat = boundingBox.maxLat;
        return data;
    }

    function copyrightsQuery(fields) {
        var modifiedFields = copyrightsParameters.modifyFields(fields);
        return function(options, callback) {
            if (options.minLon !== undefined && options.minLat !== undefined &&
                options.maxLon !== undefined && options.maxLat !== undefined) {
                return copyright.copyrightsBounds(modifiedFields, options, callback);
            } else {
                return copyright.copyrightsWorld(modifiedFields, options, callback);
            }
        };
    }

    function handleChain(data, callback) {
        copyrightsParameters.modifyRequestOptions(data);
        worldEdge(copyrightsQuery(fields), model, data, callback, addBoundingBoxParameters);
    }

    return function(options) {
        return chain(fields, handleChain, options);
    };
});



// WEBPACK FOOTER //
// ./services/copyrights/copyright.js